import { render, staticRenderFns } from "./AppRoleAssignment.vue?vue&type=template&id=e2103b1a&scoped=true"
import script from "./AppRoleAssignment.vue?vue&type=script&lang=js"
export * from "./AppRoleAssignment.vue?vue&type=script&lang=js"
import style0 from "./AppRoleAssignment.vue?vue&type=style&index=0&id=e2103b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2103b1a",
  null
  
)

export default component.exports